import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";

const StyledGrid = styled(
  DataGrid,
  {}
)(({ theme }) => ({
  borderRadius: 0,
  border: "1px solid #000",
  "& .MuiDataGrid-cell": {
    fontSize: "0.875rem",
    borderBottom: "1px solid #e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  "& .MuiDataGrid-columnSeparator": {
    color: "#000",
  },
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "rgba(112, 112, 112, 0.12)",
  },
  "& .MuiDataGrid-columnHeaderTitleContainer": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    letterSpacing: "0.17px",
    fontWeight: 700,
    fontSize: "0.875rem",
    color: "#000",
    textAlign: "center",
  },
  "& .MuiDataGrid-topContainer": {
    borderBottom: "1px #999 solid",
  },
  "& .MuiDataGrid-row": {
    borderBottom: "none", // Removed heavy #999 border to avoid double borders
    ":hover": {
      backgroundColor: "#ccc",
    },
  },

  "& .MuiDataGrid-scrollbarFiller": {
    backgroundColor: "rgba(112, 112, 112, 0.12)",
  },
  "& .MuiDataGrid-scrollbarFiller--header": {
    backgroundColor: "rgba(112, 112, 112, 0.12)",
  },
  "& .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeader:last-child": {
    backgroundColor: "rgba(112, 112, 112, 0.12)",
  },
  "& .MuiDataGrid-columnHeaders .MuiDataGrid-filler": {
    backgroundColor: "rgba(112, 112, 112, 0.12)",
  },
  "& .MuiDataGrid-columnHeaders .MuiDataGrid-scrollbarFiller": {
    backgroundColor: "rgba(112, 112, 112, 0.12)",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px #999 solid",
  },
  "& .MuiCheckbox-root": {
    color: "#500000",
  },
  "& .MuiCheckbox-root.Mui-checked": {
    color: "#500000",
  },
  "& .MuiTablePagination-root .MuiInputBase-root": {
    position: "relative",
    top: "2px",
  },
}));

const StyledDataGrid = (props) => {
  return (
    <StyledGrid
      rowHeight={50}
      columnHeaderHeight={56}
      pageSizeOptions={[10, 25, 50, 100]}
      pagination
      {...props}
      initialState={{
        ...(!props.paginationModel && { pagination: { paginationModel: { pageSize: 25 } } }),
        ...props.initialState,
      }}
      slotProps={{
        ...props.slotProps,
        pagination: {
          ...props.slotProps?.pagination,
          sx: {
            "& .MuiTablePagination-select": { color: "maroon" },
            "& .MuiTablePagination-selectIcon": { color: "maroon" },
            ...props.slotProps?.pagination?.sx,
          },
          SelectProps: {
            ...props.slotProps?.pagination?.SelectProps,
            MenuProps: {
              ...props.slotProps?.pagination?.SelectProps?.MenuProps,
              sx: {
                "& .MuiMenuItem-root.Mui-selected": {
                  color: "maroon",
                  backgroundColor: "rgba(128, 0, 0, 0.08)",
                  "&:hover": { backgroundColor: "rgba(128, 0, 0, 0.12)" }
                },
                ...props.slotProps?.pagination?.SelectProps?.MenuProps?.sx,
              }
            }
          }
        }
      }}
    />
  );
};

export default StyledDataGrid;
